import React, { useEffect } from 'react'

export default function GameFree(props) {

  return (
    <div style={{paddingLeft:5}}>
      <div style={{display: 'flex',flexDirection: 'column',alignItems: 'center',justifyContent: 'center', maxWidth: '55px',overflow: 'visible'}}>
        <img src="/resources/250627/game_free.png" alt="" />
        {props.children?.free_daily_reward && <div style={{fontSize: '11px',color: '#FF3F44',marginTop: 1.5,overflow:'hidden',textOverflow: 'ellipsis',whiteSpace: 'nowrap'}}>{props.children.free_daily_reward}</div>}
      </div>
    </div>
  )
}
